import React from 'react';
import { VStack, Input, Text, Separator, Field } from '@chakra-ui/react';
import theme from '../theme';

export default ({
	onSelected,
	onChange,
	onBlur,
	dataList,
	fieldName,
	value = '',
	isDisabled = false,
	isInvalid = false
}) => {
	const [results, setResults] = React.useState([]);
	const [highlightIndex, setHighlightIndex] = React.useState(null);
	const autoCompleteRef = React.useRef(null);

	React.useEffect(() => {
		if (autoCompleteRef.current) {
			autoCompleteRef.current.value = value;
		}
	}, [value]);

	return (
		<VStack align="flex-start" spacing={0}>
			<Field.Root invalid={isInvalid}>
				<Input
					fontSize={16}
					ref={autoCompleteRef}
					bgColor={theme.colors.white}
					autoCapitalize="off"
					autoCorrect="off"
					onBlur={() => {
						setResults([]);

						if (onBlur) {
							onBlur();
						}
					}}
					onChange={({ target }) => {
						const regex = new RegExp(`${target.value.trim().replace(/[^\w\s-]/gi, '')}`, 'i');

						setResults(dataList?.filter(data => data[fieldName]?.search(regex) >= 0).slice(0, 5) ?? []);
						setHighlightIndex(null);
						onChange(target.value);
					}}
					onKeyDown={({ key }) => {
						if (results) {
							if (key === 'ArrowDown') {
								setHighlightIndex(prevIndex =>
									typeof prevIndex !== 'number' || prevIndex >= results.length - 1 ? 0 : prevIndex + 1
								);
							} else if (key === 'ArrowUp') {
								setHighlightIndex(prevIndex =>
									typeof prevIndex !== 'number' || !prevIndex ? results.length - 1 : prevIndex - 1
								);
							} else if (key === 'Enter' && results[highlightIndex]?.[fieldName]) {
								setHighlightIndex(null);
								setResults([]);
								autoCompleteRef.current.value = results[highlightIndex][fieldName];

								if (onSelected) {
									onSelected(results[highlightIndex][fieldName]);
								}
							}
						}
					}}
					disabled={isDisabled}
					_disabled={{
						opacity: 1,
						bgColor: theme.colors.gray[400],
						color: theme.colors.black
					}}
				/>
				{autoCompleteRef.current?.value
					? results.map((item, index) => (
							<React.Fragment key={`${item[fieldName]}_${index}`}>
								<Text
									fontSize={16}
									id={`${item[fieldName]}_${index}`}
									bg={highlightIndex === index ? theme.colors.gray[600] : 'base'}
									borderRadius="base"
									w="100%"
									py="8px"
									pl="16px"
									pr="8px"
									m={0}
									onMouseEnter={() => setHighlightIndex(index)}
									onMouseLeave={() => setHighlightIndex(null)}
									onMouseDown={() => {
										setHighlightIndex(null);
										setResults([]);

										if (onSelected) {
											onSelected(item[fieldName]);
										}
									}}
								>
									{item[fieldName]}
								</Text>
								{index !== results.length - 1 ? <Separator /> : null}
							</React.Fragment>
						))
					: null}
			</Field.Root>
		</VStack>
	);
};
